<template>
    <div class="user-center__container">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'UserCenterContainerSlot'
}
</script>

<style lang="less">
@import '../../global/variable';
.user-center__container{
    display: flex;
    .pageMaxWidth();
    margin: 0 auto;
    overflow:hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/UserCenterContainerSlot.vue